module.exports = {
	"v": "5.7.4",
	"fr": 59.3302764892578,
	"ip": 0,
	"op": 103.000479999891,
	"w": 1700,
	"h": 565,
	"nm": "Hela ny",
	"ddd": 0,
	"assets": [
		{
			"id": "comp_0",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "Ring",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								747.933,
								232.48,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								288,
								-367,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667,
											0.667,
											0.667
										],
										"y": [
											1,
											1,
											1
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0.167,
											0.167,
											8.81
										]
									},
									"t": 46,
									"s": [
										50,
										50,
										100
									]
								},
								{
									"i": {
										"x": [
											0.667,
											0.667,
											0.667
										],
										"y": [
											1,
											1,
											1
										]
									},
									"o": {
										"x": [
											0.333,
											0.333,
											0.333
										],
										"y": [
											0,
											0,
											0
										]
									},
									"t": 53,
									"s": [
										108,
										108,
										100
									]
								},
								{
									"t": 57.0002656310078,
									"s": [
										100,
										100,
										100
									]
								}
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"hasMask": true,
					"masksProperties": [
						{
							"inv": false,
							"mode": "a",
							"pt": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 45,
										"s": [
											{
												"i": [
													[
														65.096,
														0
													],
													[
														0,
														-65.096
													],
													[
														-65.096,
														0
													],
													[
														0,
														65.096
													]
												],
												"o": [
													[
														-65.096,
														0
													],
													[
														0,
														65.096
													],
													[
														65.096,
														0
													],
													[
														0,
														-65.096
													]
												],
												"v": [
													[
														605.915,
														-475.498
													],
													[
														488.048,
														-357.632
													],
													[
														605.915,
														-239.765
													],
													[
														723.782,
														-357.632
													]
												],
												"c": true
											}
										]
									},
									{
										"t": 46.0002143688835,
										"s": [
											{
												"i": [
													[
														98.922,
														0
													],
													[
														0,
														-102.857
													],
													[
														-101.078,
														-5.295
													],
													[
														0,
														116.857
													]
												],
												"o": [
													[
														-131.078,
														0
													],
													[
														0,
														123.143
													],
													[
														101.078,
														5.295
													],
													[
														0,
														-116.857
													]
												],
												"v": [
													[
														287.078,
														-541.438
													],
													[
														108.672,
														-370.143
													],
													[
														287.078,
														-183.705
													],
													[
														454.406,
														-370.143
													]
												],
												"c": true
											}
										]
									}
								],
								"ix": 1
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 3
							},
							"x": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"nm": "Mask 1"
						}
					],
					"shapes": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-1.626,
											0.027
										],
										[
											0,
											86.004
										],
										[
											86.004,
											0
										],
										[
											0,
											-86.052
										],
										[
											-82.02,
											-1.334
										]
									],
									"o": [
										[
											86.243,
											0
										],
										[
											0,
											-86.004
										],
										[
											-84.422,
											0
										],
										[
											-1.334,
											82.02
										],
										[
											1.626,
											0.026
										]
									],
									"v": [
										[
											287.691,
											-217.274
										],
										[
											438.617,
											-368.199
										],
										[
											287.691,
											-520.754
										],
										[
											136.718,
											-368.199
										],
										[
											282.812,
											-217.273
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						}
					],
					"ip": 0,
					"op": 298.00138873755,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "Symbol S",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								460,
								599,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"hasMask": true,
					"masksProperties": [
						{
							"inv": false,
							"mode": "s",
							"pt": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 0,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														52.5,
														-902.5
													],
													[
														-891.5,
														-574.5
													],
													[
														-675.5,
														41.5
													],
													[
														-371.5,
														65.5
													],
													[
														12.5,
														257.5
													],
													[
														-171.5,
														173.5
													],
													[
														-507.5,
														157.5
													],
													[
														-499.5,
														833.5
													],
													[
														796.5,
														809.5
													],
													[
														468.5,
														-78.5
													],
													[
														-3.5,
														-198.5
													],
													[
														612.5,
														-158.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 47,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														52.5,
														-902.5
													],
													[
														-891.5,
														-574.5
													],
													[
														-675.5,
														41.5
													],
													[
														-371.5,
														65.5
													],
													[
														-203.5,
														125.5
													],
													[
														-171.5,
														173.5
													],
													[
														-507.5,
														157.5
													],
													[
														-499.5,
														833.5
													],
													[
														796.5,
														809.5
													],
													[
														468.5,
														-78.5
													],
													[
														-3.5,
														-198.5
													],
													[
														984.5,
														-214.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 55,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														52.5,
														-902.5
													],
													[
														-891.5,
														-574.5
													],
													[
														-675.5,
														41.5
													],
													[
														-371.5,
														65.5
													],
													[
														-243.5,
														101.5
													],
													[
														-171.5,
														173.5
													],
													[
														-507.5,
														157.5
													],
													[
														-499.5,
														833.5
													],
													[
														796.5,
														809.5
													],
													[
														468.5,
														-78.5
													],
													[
														-3.5,
														-198.5
													],
													[
														-187.5,
														-766.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 62,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-667.5,
														-358.5
													],
													[
														-891.5,
														-574.5
													],
													[
														-675.5,
														41.5
													],
													[
														-371.5,
														65.5
													],
													[
														-275.5,
														97.5
													],
													[
														-171.5,
														173.5
													],
													[
														-507.5,
														157.5
													],
													[
														-499.5,
														833.5
													],
													[
														796.5,
														809.5
													],
													[
														468.5,
														-78.5
													],
													[
														-3.5,
														-198.5
													],
													[
														-587.5,
														-142.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 69,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-311.5,
														69.5
													],
													[
														-891.5,
														-574.5
													],
													[
														-675.5,
														41.5
													],
													[
														-371.5,
														65.5
													],
													[
														-315.5,
														117.5
													],
													[
														-171.5,
														173.5
													],
													[
														-507.5,
														157.5
													],
													[
														-499.5,
														833.5
													],
													[
														796.5,
														809.5
													],
													[
														936.5,
														-102.5
													],
													[
														292.5,
														-114.5
													],
													[
														16.5,
														249.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 73,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-309.5,
														75.5
													],
													[
														-891.5,
														-574.5
													],
													[
														-675.5,
														41.5
													],
													[
														-371.5,
														65.5
													],
													[
														-295.5,
														113.5
													],
													[
														-171.5,
														173.5
													],
													[
														-507.5,
														157.5
													],
													[
														-499.5,
														833.5
													],
													[
														796.5,
														809.5
													],
													[
														954.5,
														73.5
													],
													[
														576.5,
														313.5
													],
													[
														58.5,
														277.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 77,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-307.5,
														65.5
													],
													[
														-891.5,
														-574.5
													],
													[
														-675.5,
														41.5
													],
													[
														-371.5,
														65.5
													],
													[
														-291.5,
														117.5
													],
													[
														-171.5,
														173.5
													],
													[
														-507.5,
														157.5
													],
													[
														-499.5,
														833.5
													],
													[
														796.5,
														809.5
													],
													[
														972.5,
														249.5
													],
													[
														408.5,
														733.5
													],
													[
														100.5,
														305.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 85,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-307.5,
														65.5
													],
													[
														-891.5,
														-574.5
													],
													[
														-675.5,
														41.5
													],
													[
														-371.5,
														65.5
													],
													[
														-283.5,
														121.5
													],
													[
														-171.5,
														173.5
													],
													[
														-507.5,
														157.5
													],
													[
														-499.5,
														833.5
													],
													[
														796.5,
														809.5
													],
													[
														70.5,
														791.5
													],
													[
														-413.5,
														687.5
													],
													[
														-41.5,
														243.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 91,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-307.5,
														65.5
													],
													[
														-891.5,
														-574.5
													],
													[
														-675.5,
														41.5
													],
													[
														-371.5,
														65.5
													],
													[
														-319.5,
														125.5
													],
													[
														-171.5,
														173.5
													],
													[
														-507.5,
														157.5
													],
													[
														-499.5,
														833.5
													],
													[
														796.5,
														809.5
													],
													[
														-143.184,
														769.395
													],
													[
														-460.868,
														416.974
													],
													[
														-96.237,
														198.869
													]
												],
												"c": true
											}
										]
									},
									{
										"t": 97.0004520387326,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-307.5,
														65.5
													],
													[
														-891.5,
														-574.5
													],
													[
														-675.5,
														41.5
													],
													[
														-371.5,
														65.5
													],
													[
														-331.5,
														121.5
													],
													[
														-201.5,
														171.5
													],
													[
														-507.5,
														157.5
													],
													[
														-499.5,
														833.5
													],
													[
														796.5,
														809.5
													],
													[
														-335.5,
														749.5
													],
													[
														-503.5,
														173.5
													],
													[
														-151.5,
														183.5
													]
												],
												"c": true
											}
										]
									}
								],
								"ix": 1
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 3
							},
							"x": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"nm": "Mask symbol"
						}
					],
					"shapes": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											247.805,
											40.103
										],
										[
											33.683,
											12.697
										],
										[
											0,
											66.503
										],
										[
											-95.73,
											0
										],
										[
											-21.15,
											-4.71
										],
										[
											0,
											0
										],
										[
											18.015,
											0
										],
										[
											0,
											-212.589
										],
										[
											-223.418,
											-40.534
										],
										[
											-36.174,
											-5.702
										],
										[
											0,
											-71.438
										],
										[
											110.343,
											0
										],
										[
											0,
											120.118
										],
										[
											0,
											0
										],
										[
											-275.93,
											0
										],
										[
											0,
											217.477
										]
									],
									"o": [
										[
											-35.551,
											-5.749
										],
										[
											-63.101,
											-23.956
										],
										[
											0,
											-79.487
										],
										[
											21.667,
											-0.285
										],
										[
											0,
											0
										],
										[
											-17.345,
											-1.629
										],
										[
											-254.801,
											0
										],
										[
											0,
											173.684
										],
										[
											0,
											0
										],
										[
											61.856,
											9.822
										],
										[
											0,
											82.793
										],
										[
											-129.844,
											0
										],
										[
											0,
											0
										],
										[
											0,
											256.478
										],
										[
											269.462,
											0
										],
										[
											0,
											-176.894
										]
									],
									"v": [
										[
											96.52,
											-117.051
										],
										[
											-49.47,
											-145.368
										],
										[
											-166.426,
											-264.575
										],
										[
											-8.936,
											-392.885
										],
										[
											55.507,
											-386.226
										],
										[
											55.507,
											-596.419
										],
										[
											2.42,
											-598.911
										],
										[
											-427.646,
											-240.235
										],
										[
											-91.394,
											93.909
										],
										[
											64.131,
											124.765
										],
										[
											189.328,
											251.542
										],
										[
											13.823,
											394.371
										],
										[
											-206.912,
											193.137
										],
										[
											-460.131,
											193.137
										],
										[
											5.678,
											598.911
										],
										[
											460.131,
											232.09
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						}
					],
					"ip": 0,
					"op": 298.00138873755,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 4,
					"nm": "S",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								460,
								599,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"hasMask": true,
					"masksProperties": [
						{
							"inv": false,
							"mode": "a",
							"pt": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 0,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														52.5,
														-902.5
													],
													[
														-891.5,
														-574.5
													],
													[
														-675.5,
														41.5
													],
													[
														-371.5,
														65.5
													],
													[
														-299.5,
														91.5
													],
													[
														-171.5,
														173.5
													],
													[
														-507.5,
														157.5
													],
													[
														-499.5,
														833.5
													],
													[
														796.5,
														809.5
													],
													[
														468.5,
														-78.5
													],
													[
														-3.5,
														-198.5
													],
													[
														612.5,
														-158.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 30,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														52.5,
														-902.5
													],
													[
														-891.5,
														-574.5
													],
													[
														-675.5,
														41.5
													],
													[
														-371.5,
														65.5
													],
													[
														-263.5,
														103.5
													],
													[
														-171.5,
														173.5
													],
													[
														-507.5,
														157.5
													],
													[
														-499.5,
														833.5
													],
													[
														796.5,
														809.5
													],
													[
														468.5,
														-78.5
													],
													[
														-3.5,
														-198.5
													],
													[
														984.5,
														-214.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 38,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														52.5,
														-902.5
													],
													[
														-891.5,
														-574.5
													],
													[
														-675.5,
														41.5
													],
													[
														-371.5,
														65.5
													],
													[
														-255.5,
														99.5
													],
													[
														-171.5,
														173.5
													],
													[
														-507.5,
														157.5
													],
													[
														-499.5,
														833.5
													],
													[
														796.5,
														809.5
													],
													[
														468.5,
														-78.5
													],
													[
														-3.5,
														-198.5
													],
													[
														-187.5,
														-766.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 45,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-667.5,
														-358.5
													],
													[
														-891.5,
														-574.5
													],
													[
														-675.5,
														41.5
													],
													[
														-371.5,
														65.5
													],
													[
														-215.5,
														117.499
													],
													[
														-171.5,
														173.5
													],
													[
														-507.5,
														157.5
													],
													[
														-499.5,
														833.5
													],
													[
														796.5,
														809.5
													],
													[
														468.5,
														-78.5
													],
													[
														-3.5,
														-198.5
													],
													[
														-523.5,
														-102.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 52,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-275.5,
														73.5
													],
													[
														-891.5,
														-574.5
													],
													[
														-675.5,
														41.5
													],
													[
														-371.5,
														65.5
													],
													[
														-161.5,
														149.499
													],
													[
														-171.5,
														173.5
													],
													[
														-507.5,
														157.5
													],
													[
														-499.5,
														833.5
													],
													[
														796.5,
														809.5
													],
													[
														936.5,
														-102.5
													],
													[
														292.5,
														-114.5
													],
													[
														16.5,
														185.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 56,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-313.5,
														59.5
													],
													[
														-891.5,
														-574.5
													],
													[
														-675.5,
														41.5
													],
													[
														-371.5,
														65.5
													],
													[
														-227.5,
														125.5
													],
													[
														-185.5,
														179.5
													],
													[
														-507.5,
														157.5
													],
													[
														-499.5,
														833.5
													],
													[
														796.5,
														809.5
													],
													[
														954.5,
														73.5
													],
													[
														576.5,
														313.5
													],
													[
														42.5,
														221.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 60,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-307.5,
														65.5
													],
													[
														-891.5,
														-574.5
													],
													[
														-675.5,
														41.5
													],
													[
														-371.5,
														65.5
													],
													[
														-223.5,
														127.5
													],
													[
														-193.5,
														173.5
													],
													[
														-507.5,
														157.5
													],
													[
														-499.5,
														833.5
													],
													[
														796.5,
														809.5
													],
													[
														972.5,
														249.5
													],
													[
														460.5,
														757.5
													],
													[
														84.5,
														233.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 68,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-307.5,
														65.5
													],
													[
														-891.5,
														-574.5
													],
													[
														-675.5,
														41.5
													],
													[
														-371.5,
														65.5
													],
													[
														-241.5,
														129.5
													],
													[
														-195.5,
														175.5
													],
													[
														-507.5,
														157.5
													],
													[
														-499.5,
														833.5
													],
													[
														796.5,
														809.5
													],
													[
														70.5,
														791.5
													],
													[
														-413.5,
														687.5
													],
													[
														26.5,
														271.5
													]
												],
												"c": true
											}
										]
									},
									{
										"t": 76.0003541746771,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-307.5,
														65.5
													],
													[
														-891.5,
														-574.5
													],
													[
														-675.5,
														41.5
													],
													[
														-371.5,
														65.5
													],
													[
														-339.5,
														97.5
													],
													[
														-273.5,
														151.499
													],
													[
														-507.5,
														157.5
													],
													[
														-499.5,
														833.5
													],
													[
														796.5,
														809.5
													],
													[
														-335.5,
														749.5
													],
													[
														-491.5,
														177.5
													],
													[
														-183.5,
														181.5
													]
												],
												"c": true
											}
										]
									}
								],
								"ix": 1
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 3
							},
							"x": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"nm": "Mask 1"
						}
					],
					"shapes": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											247.845,
											40.191
										],
										[
											33.687,
											12.717
										],
										[
											0,
											66.354
										],
										[
											-95.721,
											0
										],
										[
											-1.602,
											-105.769
										],
										[
											0,
											0
										],
										[
											240.176,
											0
										],
										[
											0,
											-212.605
										],
										[
											-223.381,
											-40.531
										],
										[
											-35.968,
											-5.728
										],
										[
											0,
											-71.451
										],
										[
											110.331,
											0
										],
										[
											0,
											120.136
										],
										[
											0,
											0
										],
										[
											-276.096,
											0
										],
										[
											0,
											217.508
										]
									],
									"o": [
										[
											-35.531,
											-5.728
										],
										[
											-63.102,
											-23.736
										],
										[
											0,
											-79.266
										],
										[
											105.526,
											0
										],
										[
											0,
											0
										],
										[
											4.854,
											-230.516
										],
										[
											-254.835,
											0
										],
										[
											0,
											173.676
										],
										[
											0,
											0
										],
										[
											61.84,
											9.708
										],
										[
											0,
											82.761
										],
										[
											-129.844,
											0
										],
										[
											0,
											0
										],
										[
											0,
											256.485
										],
										[
											269.445,
											0
										],
										[
											-0.194,
											-176.88
										]
									],
									"v": [
										[
											96.376,
											-117.054
										],
										[
											-49.583,
											-145.353
										],
										[
											-166.565,
											-264.567
										],
										[
											-9.053,
											-397.664
										],
										[
											169.477,
											-219.085
										],
										[
											427.564,
											-219.085
										],
										[
											2.354,
											-598.911
										],
										[
											-427.759,
											-240.2
										],
										[
											-91.522,
											93.901
										],
										[
											63.806,
											124.772
										],
										[
											188.991,
											251.558
										],
										[
											13.518,
											394.363
										],
										[
											-207.242,
											193.116
										],
										[
											-460.232,
											193.116
										],
										[
											5.752,
											598.911
										],
										[
											460.232,
											232.094
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						}
					],
					"ip": 0,
					"op": 298.00138873755,
					"st": 0,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_1",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "Shape Layer 1",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								449.5,
								582,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"hasMask": true,
					"masksProperties": [
						{
							"inv": false,
							"mode": "a",
							"pt": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 0,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-233,
														-1237.5
													],
													[
														-713,
														-645.5
													],
													[
														-657,
														602.5
													],
													[
														-177,
														658.5
													],
													[
														-177,
														290.5
													],
													[
														55,
														650.5
													],
													[
														61.103,
														646.89
													],
													[
														192.595,
														569.118
													],
													[
														1367,
														-125.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 31,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-233,
														-1237.5
													],
													[
														-713,
														-645.5
													],
													[
														-657,
														602.5
													],
													[
														-177,
														658.5
													],
													[
														-177,
														290.5
													],
													[
														55,
														650.5
													],
													[
														61.103,
														646.89
													],
													[
														192.595,
														569.118
													],
													[
														1367,
														-125.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 32,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-233,
														-1237.5
													],
													[
														-713,
														-645.5
													],
													[
														-657,
														602.5
													],
													[
														-193,
														666.5
													],
													[
														-200.5,
														201.5
													],
													[
														-198.5,
														-139.5
													],
													[
														-117.59,
														-76.152
													],
													[
														-169.334,
														288.965
													],
													[
														1287,
														622.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 35,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-233,
														-1237.5
													],
													[
														-713,
														-645.5
													],
													[
														-657,
														602.5
													],
													[
														-193,
														666.5
													],
													[
														-201,
														202.5
													],
													[
														-198.5,
														-139.5
													],
													[
														2.41,
														-136.152
													],
													[
														290.666,
														308.965
													],
													[
														1259,
														6.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 39,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-233,
														-1237.5
													],
													[
														-713,
														-645.5
													],
													[
														-657,
														602.5
													],
													[
														-193,
														666.5
													],
													[
														-200.5,
														202
													],
													[
														-199,
														-139.5
													],
													[
														2.41,
														-136.152
													],
													[
														494.666,
														-331.035
													],
													[
														367,
														-797.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 46,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-233,
														-1237.5
													],
													[
														-713,
														-645.5
													],
													[
														-657,
														602.5
													],
													[
														-193,
														666.5
													],
													[
														-201,
														202
													],
													[
														-198,
														-139.5
													],
													[
														2.41,
														-136.152
													],
													[
														-469.334,
														-611.035
													],
													[
														-601,
														-597.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 50,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-233,
														-1237.5
													],
													[
														-713,
														-645.5
													],
													[
														-657,
														602.5
													],
													[
														-193,
														666.5
													],
													[
														-201,
														203.5
													],
													[
														-198.5,
														-142.5
													],
													[
														-185.59,
														-180.152
													],
													[
														-585.334,
														-211.035
													],
													[
														-601,
														-597.5
													]
												],
												"c": true
											}
										]
									},
									{
										"t": 62.0002889319734,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-233,
														-1237.5
													],
													[
														-713,
														-645.5
													],
													[
														-825,
														1402.5
													],
													[
														-145,
														1550.5
													],
													[
														-189,
														1011
													],
													[
														-193,
														678.5
													],
													[
														-197.59,
														599.849
													],
													[
														-609.334,
														592.965
													],
													[
														-601,
														-597.5
													]
												],
												"c": true
											}
										]
									}
								],
								"ix": 1
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 3
							},
							"x": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"nm": "Mask 1"
						}
					],
					"shapes": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											114.797
										],
										[
											-115.04,
											0
										],
										[
											0,
											-114.797
										],
										[
											114.797,
											0
										]
									],
									"o": [
										[
											-114.846,
											0
										],
										[
											0,
											-114.797
										],
										[
											115.04,
											0
										],
										[
											0,
											114.797
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-0.097,
											73.805
										],
										[
											-199.111,
											-138.606
										],
										[
											-0.097,
											-351.017
										],
										[
											198.675,
											-138.606
										],
										[
											-0.048,
											73.805
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											253.185,
											0
										],
										[
											0.631,
											-246.098
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-105.914,
											0
										],
										[
											0,
											245.321
										]
									],
									"o": [
										[
											-254.35,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											71.305,
											73.295
										],
										[
											228.138,
											0
										],
										[
											-0.049,
											-246.438
										]
									],
									"v": [
										[
											-0.097,
											-581.485
										],
										[
											-449.577,
											-138.8
										],
										[
											-449.577,
											-138.8
										],
										[
											-449.577,
											581.485
										],
										[
											-201.295,
											581.485
										],
										[
											-201.295,
											201.368
										],
										[
											43.055,
											303.982
										],
										[
											449.578,
											-137.732
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						}
					],
					"ip": 0,
					"op": 298.00138873755,
					"st": 0,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_2",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "Shape Layer 1",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								450,
								443,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"hasMask": true,
					"masksProperties": [
						{
							"inv": false,
							"mode": "a",
							"pt": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 24,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														630.5,
														-514.5
													],
													[
														-609.5,
														-514.5
													],
													[
														-625.5,
														493.5
													],
													[
														-9.5,
														549.5
													],
													[
														54.5,
														485.5
													],
													[
														182.5,
														549.5
													],
													[
														622.5,
														477.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 25,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														630.5,
														-514.5
													],
													[
														-609.5,
														-514.5
													],
													[
														-625.5,
														493.5
													],
													[
														-9.5,
														549.5
													],
													[
														-9.5,
														-26.5
													],
													[
														486.5,
														557.5
													],
													[
														622.5,
														477.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 29,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-289.5,
														-850.5
													],
													[
														-609.5,
														-514.5
													],
													[
														-625.5,
														493.5
													],
													[
														-9.5,
														549.5
													],
													[
														-9.5,
														-26.5
													],
													[
														918.5,
														-442.5
													],
													[
														246.5,
														-842.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 33,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-1217.5,
														-82.5
													],
													[
														-1105.5,
														389.5
													],
													[
														-625.5,
														493.5
													],
													[
														-9.5,
														549.5
													],
													[
														-9.5,
														-26.5
													],
													[
														-177.5,
														-618.5
													],
													[
														-1217.5,
														-346.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 38,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-1217.5,
														-82.5
													],
													[
														-1105.5,
														389.5
													],
													[
														-625.5,
														493.5
													],
													[
														-9.5,
														549.5
													],
													[
														-9.5,
														-26.5
													],
													[
														-689.5,
														237.5
													],
													[
														-1217.5,
														-346.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 43,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-1217.5,
														-82.5
													],
													[
														-1105.5,
														389.5
													],
													[
														-625.5,
														493.5
													],
													[
														-9.5,
														549.5
													],
													[
														-9.5,
														-26.5
													],
													[
														-97.5,
														509.5
													],
													[
														-433.5,
														437.5
													]
												],
												"c": true
											}
										]
									},
									{
										"t": 44.0002050484973,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-1217.5,
														-82.5
													],
													[
														-1105.5,
														389.5
													],
													[
														-625.5,
														493.5
													],
													[
														222.5,
														869.5
													],
													[
														30.5,
														557.5
													],
													[
														-97.5,
														509.5
													],
													[
														-433.5,
														437.5
													]
												],
												"c": true
											}
										]
									}
								],
								"ix": 1
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 3
							},
							"x": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"nm": "Mask 2"
						}
					],
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0,
											0.274509803922,
											1,
											1
										],
										"ix": 4
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 5
									},
									"r": 1,
									"bm": 0,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Shape 1",
							"np": 2,
							"cix": 2,
							"bm": 0,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											248.282,
											0
										],
										[
											0,
											-244.496
										],
										[
											-248.282,
											0
										],
										[
											0,
											244.496
										]
									],
									"o": [
										[
											-248.282,
											0
										],
										[
											0,
											244.496
										],
										[
											248.282,
											0
										],
										[
											0,
											-244.496
										]
									],
									"v": [
										[
											-0.242,
											-442.733
										],
										[
											-449.577,
											0.049
										],
										[
											0,
											442.733
										],
										[
											449.578,
											0.048
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 2,
							"ty": "sh",
							"ix": 3,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											114.797,
											0
										],
										[
											0,
											114.797
										],
										[
											-115.04,
											0
										],
										[
											0,
											-114.797
										]
									],
									"o": [
										[
											-114.846,
											0
										],
										[
											0,
											-114.797
										],
										[
											115.04,
											0
										],
										[
											0,
											114.797
										]
									],
									"v": [
										[
											-0.242,
											212.557
										],
										[
											-199.257,
											0.146
										],
										[
											-0.242,
											-212.265
										],
										[
											198.529,
											0.146
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						}
					],
					"ip": 0,
					"op": 298.00138873755,
					"st": 0,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_3",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "Shape Layer 2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								278,
								513,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"hasMask": true,
					"masksProperties": [
						{
							"inv": false,
							"mode": "a",
							"pt": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 0,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-165.5,
														-536.5
													],
													[
														-153.5,
														-336.5
													],
													[
														-285.5,
														-336.5
													],
													[
														-293.5,
														-88.5
													],
													[
														-181.5,
														-72.5
													],
													[
														-165.5,
														507.5
													],
													[
														306.5,
														527.5
													],
													[
														310.5,
														267.5
													],
													[
														132.74,
														231.82
													],
													[
														118.5,
														-104.5
													],
													[
														286.5,
														-104.5
													],
													[
														290.5,
														-332.5
													],
													[
														118.5,
														-328.5
													],
													[
														114.5,
														-540.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 19,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-165.5,
														-536.5
													],
													[
														-153.5,
														-336.5
													],
													[
														-285.5,
														-336.5
													],
													[
														-293.5,
														-88.5
													],
													[
														-181.5,
														-72.5
													],
													[
														-165.5,
														507.5
													],
													[
														306.5,
														527.5
													],
													[
														310.5,
														267.5
													],
													[
														132.74,
														231.82
													],
													[
														118.5,
														-104.5
													],
													[
														286.5,
														-104.5
													],
													[
														290.5,
														-332.5
													],
													[
														118.5,
														-328.5
													],
													[
														114.5,
														-540.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 24,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-165.5,
														-536.5
													],
													[
														-153.5,
														-336.5
													],
													[
														-195.5,
														-334.5
													],
													[
														-195.5,
														-104.5
													],
													[
														-153.5,
														-104.5
													],
													[
														-165.5,
														507.5
													],
													[
														-21.5,
														631.5
													],
													[
														178.5,
														251.5
													],
													[
														132.74,
														231.82
													],
													[
														118.5,
														-104.5
													],
													[
														166.5,
														-96.5
													],
													[
														170.5,
														-340.5
													],
													[
														118.5,
														-328.5
													],
													[
														114.5,
														-540.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 29,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-165.5,
														-536.5
													],
													[
														-231.5,
														-526.5
													],
													[
														-143.5,
														-348.5
													],
													[
														-142.5,
														-326.5
													],
													[
														-142.5,
														-117.5
													],
													[
														-153.5,
														-32.5
													],
													[
														-149.5,
														155.5
													],
													[
														138.5,
														147.5
													],
													[
														112.74,
														67.82
													],
													[
														118.5,
														-104.5
													],
													[
														104.25,
														-117.5
													],
													[
														104.5,
														-321.5
													],
													[
														118.5,
														-328.5
													],
													[
														114.5,
														-540.5
													]
												],
												"c": true
											}
										]
									},
									{
										"t": 36.0001677669523,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-217.5,
														-1480.5
													],
													[
														-321.5,
														-1292.5
													],
													[
														-153.5,
														-1176.5
													],
													[
														-137.5,
														-988.5
													],
													[
														-139.5,
														-778.5
													],
													[
														-143.5,
														-638.5
													],
													[
														-139.5,
														-520.5
													],
													[
														104.5,
														-526.5
													],
													[
														108.74,
														-700.18
													],
													[
														102.5,
														-752.5
													],
													[
														112.25,
														-777.5
													],
													[
														192.5,
														-785.5
													],
													[
														150.5,
														-860.5
													],
													[
														6.5,
														-1008.5
													]
												],
												"c": true
											}
										]
									}
								],
								"ix": 1
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 3
							},
							"x": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"nm": "Mask 1"
						}
					],
					"shapes": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											72.81
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-165.521,
											0
										],
										[
											-41.892,
											8.969
										],
										[
											0,
											0
										],
										[
											23.715,
											-0.047
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											209.353
										],
										[
											42.831,
											-0.943
										],
										[
											0,
											0
										],
										[
											-23.343,
											4.184
										],
										[
											-63.102,
											0
										]
									],
									"v": [
										[
											103.511,
											185.083
										],
										[
											103.511,
											-123.34
										],
										[
											277.188,
											-123.34
										],
										[
											277.188,
											-318.083
										],
										[
											103.511,
											-318.083
										],
										[
											103.511,
											-512.874
										],
										[
											-141.567,
											-512.874
										],
										[
											-141.567,
											-318.083
										],
										[
											-277.916,
											-318.083
										],
										[
											-277.916,
											-123.34
										],
										[
											-141.567,
											-123.34
										],
										[
											-141.567,
											202.897
										],
										[
											150.547,
											512.874
										],
										[
											277.916,
											497.972
										],
										[
											277.916,
											290.658
										],
										[
											207.193,
											297.016
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509817362,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						}
					],
					"ip": 0,
					"op": 298.00138873755,
					"st": 0,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_4",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "Shape Layer 2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": 0.833,
										"y": 0.833
									},
									"o": {
										"x": 0.167,
										"y": 0.167
									},
									"t": 2,
									"s": [
										151.5,
										660,
										0
									],
									"to": [
										0,
										0,
										0
									],
									"ti": [
										0,
										0,
										0
									]
								},
								{
									"i": {
										"x": 0.833,
										"y": 0.833
									},
									"o": {
										"x": 0.167,
										"y": 0.167
									},
									"t": 6,
									"s": [
										151.5,
										612,
										0
									],
									"to": [
										0,
										0,
										0
									],
									"ti": [
										0,
										0,
										0
									]
								},
								{
									"i": {
										"x": 0.833,
										"y": 0.833
									},
									"o": {
										"x": 0.333,
										"y": 0
									},
									"t": 12,
									"s": [
										151.5,
										660,
										0
									],
									"to": [
										0,
										72,
										0
									],
									"ti": [
										0,
										-72,
										0
									]
								},
								{
									"t": 29.0001351456005,
									"s": [
										151.5,
										1092,
										0
									]
								}
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								457,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											0.833,
											0.833,
											0.833
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0.167,
											0.167,
											0.167
										]
									},
									"t": 12,
									"s": [
										100,
										100,
										100
									]
								},
								{
									"t": 29.0001351456005,
									"s": [
										80,
										80,
										100
									]
								}
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											86.013,
											0
										],
										[
											0,
											-86.013
										],
										[
											-82.075,
											-1.297
										],
										[
											-1.549,
											0.024
										],
										[
											0,
											86.013
										]
									],
									"o": [
										[
											-84.363,
											0
										],
										[
											-1.296,
											82.076
										],
										[
											1.549,
											0.024
										],
										[
											86.013,
											0
										],
										[
											0,
											-86.013
										]
									],
									"v": [
										[
											0.624,
											-151.748
										],
										[
											-150.287,
											0.765
										],
										[
											-4.024,
											151.723
										],
										[
											0.624,
											151.724
										],
										[
											151.583,
											0.765
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						}
					],
					"ip": 0,
					"op": 25.000116504828,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "Shape Layer 1",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								151.5,
								660,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"hasMask": true,
					"masksProperties": [
						{
							"inv": false,
							"mode": "a",
							"pt": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.333,
											"y": 0
										},
										"t": 22,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														188.344,
														-265
													],
													[
														-207,
														-265
													],
													[
														-207,
														626.062
													],
													[
														188.344,
														626.062
													]
												],
												"c": true
											}
										]
									},
									{
										"t": 34.0001584465661,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														188.344,
														627
													],
													[
														-207,
														627
													],
													[
														-207,
														1518.063
													],
													[
														188.344,
														1518.063
													]
												],
												"c": true
											}
										]
									}
								],
								"ix": 1
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 3
							},
							"x": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"nm": "Mask 1"
						}
					],
					"shapes": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-123.83,
											-214.425
										],
										[
											124.5,
											-214.425
										],
										[
											124.5,
											608.425
										],
										[
											-123.83,
											608.425
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						}
					],
					"ip": 0,
					"op": 299.001393397743,
					"st": 0,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_5",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "Shape Layer 1",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								395.5,
								429.5,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"hasMask": true,
					"masksProperties": [
						{
							"inv": false,
							"mode": "a",
							"pt": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 2,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														9,
														-477
													],
													[
														-291,
														-387.153
													],
													[
														-423,
														-105.894
													],
													[
														-419,
														441
													],
													[
														-115,
														441
													],
													[
														-111,
														-74.643
													],
													[
														-3,
														-160.583
													],
													[
														113,
														-86.362
													],
													[
														129,
														441
													],
													[
														417,
														437.094
													],
													[
														425,
														-121.519
													],
													[
														309,
														-387.153
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 7,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														9,
														-477
													],
													[
														-291,
														-387.153
													],
													[
														-423,
														-105.894
													],
													[
														-419,
														441
													],
													[
														-115,
														441
													],
													[
														-111,
														-74.643
													],
													[
														-3,
														-160.583
													],
													[
														113,
														-86.362
													],
													[
														133,
														231
													],
													[
														413,
														235.094
													],
													[
														425,
														-121.519
													],
													[
														309,
														-387.153
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 12,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														9,
														-477
													],
													[
														-291,
														-387.153
													],
													[
														-423,
														-105.894
													],
													[
														-419,
														441
													],
													[
														-115,
														441
													],
													[
														-111,
														-74.643
													],
													[
														-3,
														-160.583
													],
													[
														113,
														-86.362
													],
													[
														125,
														7
													],
													[
														421,
														-24.906
													],
													[
														425,
														-121.519
													],
													[
														309,
														-387.153
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 15,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														9,
														-477
													],
													[
														-291,
														-387.153
													],
													[
														-423,
														-105.894
													],
													[
														-419,
														441
													],
													[
														-115,
														441
													],
													[
														-111,
														-74.643
													],
													[
														-3,
														-160.583
													],
													[
														1,
														-102.362
													],
													[
														83,
														-95
													],
													[
														373,
														-314.906
													],
													[
														363,
														-353.519
													],
													[
														309,
														-387.153
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 18,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-481,
														-401
													],
													[
														-553,
														-339.153
													],
													[
														-545,
														-75.894
													],
													[
														-419,
														441
													],
													[
														-115,
														441
													],
													[
														-111,
														-74.643
													],
													[
														-59,
														-30.583
													],
													[
														1,
														-42.362
													],
													[
														-45,
														-119
													],
													[
														-55,
														-518.906
													],
													[
														-301,
														-473.519
													],
													[
														-397,
														-471.153
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 21,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-481,
														-401
													],
													[
														-553,
														-339.153
													],
													[
														-545,
														-75.894
													],
													[
														-419,
														441
													],
													[
														-115,
														441
													],
													[
														-99,
														75.357
													],
													[
														-59,
														-30.583
													],
													[
														1,
														-42.362
													],
													[
														-67,
														-79
													],
													[
														-411,
														-252.906
													],
													[
														-301,
														-473.519
													],
													[
														-397,
														-471.153
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 24,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-635,
														65
													],
													[
														-691,
														72.847
													],
													[
														-657,
														272.106
													],
													[
														-419,
														441
													],
													[
														-115,
														441
													],
													[
														-19,
														419.358
													],
													[
														-7,
														275.417
													],
													[
														-47,
														307.638
													],
													[
														-121,
														245
													],
													[
														-447,
														185.094
													],
													[
														-507,
														154.481
													],
													[
														-559,
														88.847
													]
												],
												"c": true
											}
										]
									},
									{
										"t": 27.0001258252142,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-635,
														65
													],
													[
														-691,
														72.847
													],
													[
														-657,
														272.106
													],
													[
														-419,
														513
													],
													[
														-107,
														507
													],
													[
														-19,
														419.358
													],
													[
														-7,
														275.417
													],
													[
														-47,
														307.639
													],
													[
														-127,
														471
													],
													[
														-411,
														461.094
													],
													[
														-507,
														154.481
													],
													[
														-559,
														88.847
													]
												],
												"c": true
											}
										]
									}
								],
								"ix": 1
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 3
							},
							"x": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"nm": "Mask 1"
						}
					],
					"shapes": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											218.284,
											0
										],
										[
											0,
											-238.817
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-92.517,
											0
										],
										[
											0,
											-108.924
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											-218.43,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-116.836
										],
										[
											92.517,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-238.817
										]
									],
									"v": [
										[
											0,
											-429.215
										],
										[
											-395.213,
											-34.051
										],
										[
											-395.213,
											429.166
										],
										[
											-146.882,
											429.166
										],
										[
											-146.882,
											5.315
										],
										[
											0.825,
											-179.671
										],
										[
											146.882,
											-7.645
										],
										[
											146.882,
											429.215
										],
										[
											395.212,
											429.215
										],
										[
											395.212,
											-33.954
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						}
					],
					"ip": 0,
					"op": 298.00138873755,
					"st": 0,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_6",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "Shape Layer 2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								162.5,
								164,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-112.432,
											-33.183
										],
										[
											-82.337,
											-33.183
										],
										[
											-82.337,
											54.577
										],
										[
											-57.582,
											54.577
										],
										[
											-57.582,
											-33.183
										],
										[
											-27.487,
											-33.183
										],
										[
											-27.487,
											-52.842
										],
										[
											-112.432,
											-52.842
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-18.145,
											-52.838
										],
										[
											16.221,
											-52.838
										],
										[
											41.996,
											29.68
										],
										[
											67.917,
											-52.838
										],
										[
											101.895,
											-52.838
										],
										[
											101.895,
											54.581
										],
										[
											78.304,
											54.581
										],
										[
											79.809,
											-21.967
										],
										[
											54.519,
											54.581
										],
										[
											29.667,
											54.581
										],
										[
											4.474,
											-21.967
										],
										[
											6.027,
											54.581
										],
										[
											-17.902,
											54.581
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						}
					],
					"ip": 0,
					"op": 298.00138873755,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "Shape Layer 1",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								162.5,
								164,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"hasMask": true,
					"masksProperties": [
						{
							"inv": false,
							"mode": "s",
							"pt": {
								"a": 0,
								"k": {
									"i": [
										[
											81.499,
											0
										],
										[
											0.835,
											78.087
										],
										[
											-0.011,
											1.025
										],
										[
											-80.14,
											0
										],
										[
											0,
											-82.372
										]
									],
									"o": [
										[
											-78.087,
											0.836
										],
										[
											-0.011,
											-1.025
										],
										[
											0,
											-81.013
										],
										[
											81.499,
											0
										],
										[
											0,
											81.644
										]
									],
									"v": [
										[
											0.972,
											144.245
										],
										[
											-141.931,
											4.37
										],
										[
											-141.93,
											1.295
										],
										[
											0.972,
											-143.257
										],
										[
											143.874,
											1.295
										]
									],
									"c": true
								},
								"ix": 1
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 3
							},
							"x": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"nm": "Mask 1"
						}
					],
					"shapes": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											92.517,
											0
										],
										[
											0,
											-91.935
										],
										[
											-88.702,
											-0.943
										],
										[
											-1.139,
											0.012
										],
										[
											0,
											92.566
										]
									],
									"o": [
										[
											-91.013,
											0
										],
										[
											-0.943,
											88.702
										],
										[
											1.139,
											0.012
										],
										[
											92.517,
											0
										],
										[
											0,
											-93.439
										]
									],
									"v": [
										[
											0.472,
											-163.125
										],
										[
											-161.846,
											0.795
										],
										[
											-2.944,
											163.113
										],
										[
											0.472,
											163.113
										],
										[
											162.789,
											0.795
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						}
					],
					"ip": 0,
					"op": 298.00138873755,
					"st": 0,
					"bm": 0
				}
			]
		}
	],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 0,
			"nm": "Logo_S",
			"refId": "comp_0",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						162,
						245.75,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						460,
						599,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						35,
						35,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"w": 920,
			"h": 1198,
			"ip": 0,
			"op": 103.000479999891,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 0,
			"nm": "Logo_P",
			"refId": "comp_1",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						506.625,
						347.625,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						449.5,
						582,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						35,
						35,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"hasMask": true,
			"masksProperties": [
				{
					"inv": false,
					"mode": "n",
					"pt": {
						"a": 0,
						"k": {
							"i": [
								[
									0,
									0
								]
							],
							"o": [
								[
									0,
									0
								]
							],
							"v": [
								[
									1522,
									590.214
								]
							],
							"c": false
						},
						"ix": 1
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 3
					},
					"x": {
						"a": 0,
						"k": 0,
						"ix": 4
					},
					"nm": "Mask 1"
				}
			],
			"w": 899,
			"h": 1164,
			"ip": 0,
			"op": 103.000479999891,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 0,
			"nm": "Logo_O",
			"refId": "comp_2",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.667,
								"y": 1
							},
							"o": {
								"x": 0.333,
								"y": 0
							},
							"t": 39,
							"s": [
								845,
								299,
								0
							],
							"to": [
								-13.109,
								0,
								0
							],
							"ti": [
								13.109,
								0,
								0
							]
						},
						{
							"t": 50.000233009656,
							"s": [
								766.346,
								299,
								0
							]
						}
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						450,
						443,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						35,
						35,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"w": 900,
			"h": 886,
			"ip": 0,
			"op": 103.000479999891,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 0,
			"nm": "Logo_T",
			"refId": "comp_3",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.667,
								"y": 1
							},
							"o": {
								"x": 0.333,
								"y": 0
							},
							"t": 28,
							"s": [
								1104.875,
								268,
								0
							],
							"to": [
								-21.327,
								0,
								0
							],
							"ti": [
								21.327,
								0,
								0
							]
						},
						{
							"t": 36.0001677669523,
							"s": [
								976.915,
								268,
								0
							]
						}
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						278,
						513,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						35,
						35,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"w": 556,
			"h": 1026,
			"ip": 0,
			"op": 103.000479999891,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 5,
			"ty": 0,
			"nm": "Logo_I",
			"refId": "comp_4",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.667,
								"y": 1
							},
							"o": {
								"x": 0.333,
								"y": 0
							},
							"t": 28,
							"s": [
								1282.125,
								231.375,
								0
							],
							"to": [
								-27.366,
								0,
								0
							],
							"ti": [
								27.366,
								0,
								0
							]
						},
						{
							"t": 37.0001724271454,
							"s": [
								1117.93,
								231.375,
								0
							]
						}
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						151.5,
						660,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						35,
						35,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"w": 303,
			"h": 1320,
			"ip": 0,
			"op": 103.000479999891,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 6,
			"ty": 0,
			"nm": "Logo_N",
			"refId": "comp_5",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						1504,
						294.25,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						395.5,
						429.5,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						35,
						35,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"w": 791,
			"h": 859,
			"ip": 0,
			"op": 103.000479999891,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 7,
			"ty": 0,
			"nm": "Logo_TM",
			"refId": "comp_6",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 3,
							"s": [
								100
							]
						},
						{
							"t": 18.0000838834762,
							"s": [
								3
							]
						}
					],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						1642.25,
						71.125,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						162.5,
						164,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						35,
						35,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"w": 325,
			"h": 328,
			"ip": 0,
			"op": 103.000479999891,
			"st": 0,
			"bm": 0
		}
	],
	"markers": []
};


//////////////////
// WEBPACK FOOTER
// ./assets/animations/SpotinAnimatedLogo.json
// module id = 64
// module chunks = 0